import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  HStack,
  VStack
} from "@chakra-ui/react";
import React from "react";

export const CollapsibleSection = ({title, children, isOpen}: {
  title?: () => any,
  children: any,
  isOpen?: boolean | undefined | null
}) => {
  // Get is expanded status
  return <Accordion allowMultiple defaultIndex={isOpen ? [0] : []} w={"full"}>
    <AccordionItem border={"none"} borderTop={"1px solid"} borderColor={"gray.300"}>
      <AccordionButton px={0}>
        <HStack spacing={2} paddingY={"2"} fontSize="lg" fontWeight={"medium"}>
          <AccordionIcon h={"6"} w={"6"}/>
          {title && title()}

        </HStack>
      </AccordionButton>
      <AccordionPanel px={1}>
        <VStack alignItems={"start"} w={"full"} spacing={"6"} paddingY={"0"}>
          {children}
        </VStack>
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
}